import { render } from "./symbolLogo.vue?vue&type=template&id=1f1d39b7&scoped=true"
import script from "./symbolLogo.vue?vue&type=script&lang=js"
export * from "./symbolLogo.vue?vue&type=script&lang=js"

import "./symbolLogo.vue?vue&type=style&index=0&id=1f1d39b7&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1d39b7"]])

export default __exports__